module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kh-Ld.19ef3aa7.png";